export default __webpack_public_path__ + "static/media/webLargeScreen.580cb109.png";